import React, {useEffect} from 'react'
import {useSelector, useStore} from "react-redux"
import {Navigate, useNavigate} from "react-router";
import {setupInterceptors} from "../utils/api";
import jwtDecode from "jwt-decode";
import {EMPTY_USER_STORE} from "../_types";
import usePOST from "../hooks/usePOST";
import {usePeriodicTokenValidation} from "../hooks/usePeriodicTokenValidation";

function RouteSecured({children}) {
    const store = useStore();
    const navigate = useNavigate();

    const [request, sendRequest] = usePOST();
    usePeriodicTokenValidation(request, sendRequest, store)

    useEffect(() => {
        setupInterceptors(store, navigate);
    }, [store, navigate]);

    const user = useSelector(state => state.userReducer.user);
    const token = user?.token;

    if (token) {
        try {
            const decoded = jwtDecode(token)
            const now = Date.now() / 1000;

            if (decoded.exp < now) {
                localStorage.removeItem('userReducer');
                store.dispatch({type: EMPTY_USER_STORE});
                return <Navigate to={"/signIn"}/>;
            }
        } catch (err) {
            localStorage.removeItem('userReducer');
            store.dispatch({type: EMPTY_USER_STORE});
            return <Navigate to={"/signIn"}/>;
        }
    } else {
        return <Navigate to={"/signIn"}/>;
    }

    return <>{children}</>;
}

export default RouteSecured
